import * as Yup from "yup";

import { Routine } from "@/app/routines/routines";
import { TrainingDay } from "@/app/training/training-day";
import { TrainingObjective } from "@/app/training/training-objective";

import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const trainingWizardInitialValues = {
  genre: "",
  age: 0,
  weight: 0,
  height: 0,
  objective: undefined,
  activity: undefined,
  experience: 0,
  days: undefined,
  cicle: null,
  work: undefined,
};

export const trainingWizardInitialValuesFactory = ({
  age,
  genre,
  weight,
  height,
}: any) => {
  return {
    ...trainingWizardInitialValues,
    age,
    genre,
    weight,
    height,
  };
};

export const trainingWizardValidationSchema = Yup.object({
  genre: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  age: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  weight: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  height: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  objective: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type TrainingWizardValues = typeof trainingWizardInitialValues;

export const exerciseSearchInitialValues = {
  search: "",
  muscle: undefined,
  equipment: undefined,
  type: undefined,
};

export const trainingInitialValues: TrainingValues = {
  name: "My plan",
  objective: TrainingObjective.Hypertrophy,
  download: false,
  searchable: false,
  weeks: 4,
  training: {
    l: {
      warm: { time: undefined, routine: [] },
      main: { time: undefined, routine: [] },
      stretching: { time: undefined, routine: [] },
    },
    m: {
      warm: { time: undefined, routine: [] },
      main: { time: undefined, routine: [] },
      stretching: { time: undefined, routine: [] },
    },
    x: {
      warm: { time: undefined, routine: [] },
      main: { time: undefined, routine: [] },
      stretching: { time: undefined, routine: [] },
    },
    j: {
      warm: { time: undefined, routine: [] },
      main: { time: undefined, routine: [] },
      stretching: { time: undefined, routine: [] },
    },
    v: {
      warm: { time: undefined, routine: [] },
      main: { time: undefined, routine: [] },
      stretching: { time: undefined, routine: [] },
    },
    s: {
      warm: { time: undefined, routine: [] },
      main: { time: undefined, routine: [] },
      stretching: { time: undefined, routine: [] },
    },
    d: {
      warm: { time: undefined, routine: [] },
      main: { time: undefined, routine: [] },
      stretching: { time: undefined, routine: [] },
    },
  },
};

export type TrainingSection = { time?: number; routine: Array<Routine> };

export type TrainingValues = {
  name: string;
  weeks: number;
  objective?: TrainingObjective;
  download: boolean;
  searchable: boolean;
  training: Record<
    TrainingDay,
    {
      warm: TrainingSection;
      main: TrainingSection;
      stretching: TrainingSection;
    }
  >;
};
